import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';

/**
 * Component for the remove client dialog.
 * @param {ReplaceClientDialogProps} props - The component props.
 * @returns {ReactElement} React element representing the remove client dialog.
 */
const ReplaceClientDialog = ({
    dialogReplace,
    setDialogReplace,
    handleDialogSubmit,
    isLoading,
}: ReplaceClientDialog): ReactElement => (
    <Dialog
        disableEscapeKeyDown={isLoading}
        open={dialogReplace}
        onClose={() => {
            if (!isLoading) setDialogReplace(false);
        }}
        maxWidth="md"
        className="container-replace-client-dialog"
    >
        <DialogContent dividers className="dialog-content">
            <Box className="dialog-description">
                <Box className="dialog-head">
                    <TypographyLevel variant="one">
                        <Box>
                            Are you sure that you <br />
                            replace the current checklist?
                        </Box>
                    </TypographyLevel>
                </Box>

                <Box className="dialog-desc">
                    <TypographyLevel variant="three">
                        Once you upload a new checklist, the support team will{' '}
                        <br />
                        analyse and come back to you to approve the new
                        requirements
                    </TypographyLevel>
                </Box>
            </Box>
        </DialogContent>

        <DialogActions className="dialog-actions">
            <Box className="dialog-actions-button">
                <ButtonComp
                    width="16rem"
                    onClick={() => {
                        setDialogReplace(false);
                    }}
                    type="neutral"
                    disabled={isLoading}
                >
                    Go back
                </ButtonComp>
                <ButtonComp
                    width="16rem"
                    isLoading={isLoading}
                    loadingSize={22}
                    disabled={isLoading}
                    loadingText="PROCESSING"
                    onClick={handleDialogSubmit}
                    type="primary"
                >
                    I'm sure
                </ButtonComp>
            </Box>
        </DialogActions>
    </Dialog>
);

export default ReplaceClientDialog;
